import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLocalizedValue } from '../../../shared/lib/localization';
import { patchClick, deleteProgramClick } from '../lib/programsClick';

const ProgramItem = ({ program }) => {
  const navigate = useNavigate();
  const [isDeleted, setIsDeleted] = useState(false);

  if (isDeleted) return null;

  const title = getLocalizedValue(program?.title, 'ua') || 'Назва програми';
  const ageLabel = getLocalizedValue(program?.ageLabel, 'ua') || 'Вік';
  const coverImage = program?.coverImageUrl || '/img/prod-tst.png';
  const isActive = program?.isActive !== false;
  const statusLabel = isActive ? 'Активна' : 'Неактивна';

  const handleDelete = () => {
    deleteProgramClick(program?._id || program?.id, () => {
      setIsDeleted(true);
    });
  };

  return (
    <div className='team-item team-grid'>
      <div className="team-item__info">
        <img src={coverImage} alt={title} />
        <div className="team-item__info-txt">
          <p className='team_name'>{title}</p>
        </div>
      </div>

      <div className="team-item__info">
        <div className="team-item__info-txt">
          <p className='team_role'>{ageLabel}</p>
        </div>
      </div>

      <div className="team-item__info">
        <div className={`team-item__status ${isActive ? 'is-visible' : 'is-hidden'}`}>
          <p>{statusLabel}</p>
        </div>
      </div>

      <div className="team-item__func" style={{ display: 'flex', gap: '8px' }}>
        <button
          type="button"
          className='func-rewrite'
          onClick={() => patchClick(program?._id || program?.id, navigate)}
        >
          Редагувати
        </button>

        <button
          type="button"
          className='func-delete'
          onClick={handleDelete}
        >
          Видалити
        </button>
      </div>
    </div>
  );
};

export default ProgramItem;
